import MiscellaneousPanel from "./miscellaneousPanel.container";

export default MiscellaneousPanel;